import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import Logo from '../../../components/Logo';
import CommonHeaderRight from './CommonHeaderRight';

const DashboardHeader = () => {
	return (
		<Header>
			<HeaderLeft>
				<div className="d-flex align-items-center justify-content-center h-100 w-100">
					<Logo height={40} />
				</div>
			</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default DashboardHeader;
